<div class="serverError">
    <img src="../../../assets/serverError.avif" loading="lazy">
</div>